import { useNavigate } from 'react-router';

import { THandleLoginNextStep } from '@/shared/features/auth/hooks/use-login-next-step/use-login-next-step.types';

export const useLoginNextStep = () => {
  const navigate = useNavigate();

  const handleLoginNextStep = ({
    signInStep,
    username,
  }: THandleLoginNextStep) => {
    switch (signInStep) {
      case 'CONFIRM_SIGN_IN_WITH_NEW_PASSWORD_REQUIRED':
        navigate('/auth/create-new-password', { state: { username } });
        return;
      case 'CONFIRM_SIGN_IN_WITH_TOTP_CODE':
        navigate('/auth/mfa');
        return;
      case 'CONFIRM_SIGN_UP':
        navigate('/onboarding/confirmation', { state: { username } });
        return;
      default:
        return;
    }
  };

  return handleLoginNextStep;
};
